import { ChangeDetectionStrategy, Component, computed, EventEmitter, input, Output, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'coin-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon],
  host: { '[class]': '["type-" + type(), "bg-" + bgStyle()]' }
})
export class BannerComponent {
  public text = input.required<string>();
  public type = input.required<BannerType>();
  public icon = input<string>();
  public bgStyle = input<BannerBackground>('gradient');
  @Output() dismiss = new EventEmitter<void>();

  protected defaultIcon = computed(() => {
    switch (this.type()) {
      case 'info':
        return 'info';
      case 'warning':
        return 'warning';
      case 'error':
        return 'error';
      default:
        throw new Error(`Unknown type: ${this.type()}`);
    }
  });
}

export const BANNER_TYPES = ['info', 'warning', 'error'] as const;
export type BannerType = (typeof BANNER_TYPES)[number];

export const BANNER_BACKGROUNDS = ['gradient', 'unicolor'] as const;
export type BannerBackground = (typeof BANNER_BACKGROUNDS)[number];
